































































import { cloneDeep } from 'lodash'
import { ValidationObserver } from 'vee-validate'
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'

import CheckboxInput from "../../../../../../components/Pi/fields/CheckboxInput/CheckboxInput.vue";
import { UseFields } from '../../../../../../components/Pi/index'
import { FieldData } from '../../../../../../components/Pi/types'
import { errorNotificationWrapper } from '../../../../../../logic/helpers/NotificationService'
import PostApi from '../../../../includes/logic/Api/PostApi'
import BusinessRegistrationEmailValidationIcon
  from '../components/BusinessRegistrationEmailValidationIcon.vue'
import { CompanyData, CompanyRegistrationStep, DataAgreeInfo } from '../types'

@Component({
  components: {
    BusinessRegistrationEmailValidationIcon,
    ValidationObserver,
    CheckboxInput
  },

  data: () => ({
    CompanyRegistrationStep,
  })

})
export default class CodeEmail extends Mixins<UseFields>(UseFields) {
  @Prop() readonly value!: CompanyData

  isLoading = false
  dataAgree: DataAgreeInfo = {
    oferta: false,
    agree: false
  }

  get companyData(): CompanyData {
    return cloneDeep(this.value)
  }

  inputConfigSetup(args: FieldData): FieldData {
    args.setter = (value: any): void => {
      this.value[args.key as string] = value
    }

    return args
  }

  @Emit()
  input(): CompanyData {
    return this.companyData
  }

  @Emit()
  next(): { step: CompanyRegistrationStep } {
    return { step: CompanyRegistrationStep.FinishRegistration }
  }

  backStep() {
    this.$emit('next', { 'step': CompanyRegistrationStep.EmailValidation, })
    this.value['email'] = ''
  }

  resetRegistration() {
    this.$emit('next', { 'step': CompanyRegistrationStep.CompanyDataTin })
  }

  async onNextButtonClick(): Promise<void> {

    this.input()
    try {
      this.isLoading = true
      delete this.value['email']
      await PostApi.sendRequest('tg', 'RegisterOrganization', this.value)
      this.next()
    } catch (error: any) {
      errorNotificationWrapper(this.$t('error').toString(), error)

      this.value['inn'] = ''
      this.value['name'] = ''
      this.value['email'] = ''
      this.value['code'] = ''

      this.resetRegistration()
    } finally {
      this.isLoading = false
    }
  }

  onChangeAgree(args: FieldData): FieldData {
    args.setter = (val) => {
      args.model[args.key] = val
    }
    return args
  }

  mounted() {
    const elementLinkOferta = document.getElementById('link-oferta')
    if (elementLinkOferta !== null) {
      const projectName = this.$store.state.AdminTemplate.applicationConfig.meta.projectName.toLowerCase()
      const isRuLang = localStorage.getItem('locale') === 'ru' ? 'ru' : '';
      if (elementLinkOferta instanceof HTMLAnchorElement) {
        elementLinkOferta.target = "_blank"
        elementLinkOferta.href = `https://${ projectName }/${ isRuLang }/public-offer`
      }
    }

    const titleInput = document.querySelector('[translation-key="field_company_registration_email_title"]')
    const isElementHelp = document.getElementById('helper-email')
    if (isElementHelp === null && titleInput !== null) {
      const nextElement = titleInput.nextElementSibling
      nextElement?.insertAdjacentHTML('afterend', `<p id="helper-email" class="text-sm text-gray-500 mb-0">${ this.$t("field_company_registration_email_helper") }</p>`)
    }
  }
}
